import SimpleAssessmentController from './simple_assessment_controller'
import BloodPressureCheckMixin    from '../../support/blood_pressure_check_mixin'
import BmiMixin                   from '../../support/bmi_mixin'
import GlucoseIndicatorMixin      from '../../support/glucose_indicator_mixin'
import mixin                      from '../../support/mixin'
import WizardMixin                from '../../support/wizard_mixin'
import ScrollToErrorMixin         from '../../support/scroll_to_error_mixin'

export default class extends mixin(
  SimpleAssessmentController,
  WizardMixin,
  BloodPressureCheckMixin,
  BmiMixin,
  GlucoseIndicatorMixin,
  ScrollToErrorMixin
) {

  static targets = [
    ...super.targets,
    'singleCheckBoxDetails'
  ]

  // ==== Controllers

  // ==== Actions

  toggleSingleCheckBoxDetails({ currentTarget }) {
    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: this.singleCheckBoxDetailsTarget
    })
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
